var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c(_vm.currentTabComponent,{tag:"component"}),_c('HomeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }